import React, { useEffect, useRef } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const CKEditorComponent = ({ label, value, onChange, required = false, error }) => {
  const editorInstanceRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (editorInstanceRef.current) {
      const editor = editorInstanceRef.current;
      editor.editing.view.change(writer => {
        writer.setStyle('min-height', '500px', writer.document.getRoot());
        writer.setStyle('background-color', '#2D3748', writer.document.getRoot());
        writer.setStyle('color', '#E2E8F0', writer.document.getRoot());
        writer.setStyle('font-family', 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"', writer.document.getRoot()); // Set font family
      });
    }
  }, []);

  const borderClasses = error ? "border-red-500" : "border-border-subtle";

  return (
    <div className="mb-4" ref={containerRef}>
      <label className="block text-text-gray text-sm font-bold mb-2">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <div className={`ckeditor-container border rounded ${borderClasses}`}>
        <CKEditor
          editor={ClassicEditor}
          data={value}
          onReady={editor => {
            editorInstanceRef.current = editor;
            editor.editing.view.change(writer => {
              writer.setStyle('min-height', '500px', writer.document.getRoot());
              writer.setStyle('background-color', '#2D3748', writer.document.getRoot());
              writer.setStyle('color', '#E2E8F0', writer.document.getRoot());
              writer.setStyle('font-family', 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"', writer.document.getRoot());
            });
          }}
          onChange={(event, editor) => {
            const data = editor.getData();
            onChange(data);
          }}
          config={{
            toolbar: [
              'heading', '|',
              'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
              'undo', 'redo'
            ],
          }}
        />
      </div>
      {error && <p className="text-red-500 text-xs italic mt-1">{error}</p>}
    </div>
  );
};

export default CKEditorComponent;